export default "__VITE_ASSET__BYbRFEGd__"